<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header ref="header" class="header" data-title="회원가입" :type="'join'"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section>
          <div class="resultMsg ok">
            <p class="copy">웰몰의 회원이 되신것을 환영합니다.</p>
            <p class="desc" v-if="success">
              소요시간
              <span>{{ time | convertTimeToMS }}</span>
              으로 미션 성공!
              <br />
              선물로
              <span class="pointC1">할인쿠폰이</span>
              지급되었습니다.
            </p>
            <p class="desc" v-else>
              회원가입 선물로
              <span class="pointC1">할인쿠폰이</span>
              지급되었습니다.
              <br />
              신규 렌탈/구매시 푸짐한 혜택을
              <br />
              드리니 놓치지 마세요!
            </p>
          </div>
        </section>

        <section>
          <ul class="couponList">
            <li v-for="(coupon, index) in couponList" :key="index">
              <a class="block" :class="'bgColor' + (index % 2)">
                <div class="inner">
                  <span class="copy">{{ coupon.description }}</span>
                  <strong class="copy" style="font-size: 1.4rem;">{{ coupon.title }}</strong>
                  <span class="desc">유효기간 발급일로부터 30일</span>
                </div>
              </a>
            </li>
          </ul>

          <div class="btnArea mt20">
            <button type="button" class="btn_g m" @click="coupon">
              쿠폰 확인하기
            </button>
          </div>
          <p class="ac">
            <span class="txtList_star">쿠폰은 설정>쿠폰함에서 확인 가능합니다.</span>
          </p>

          <div class="btnArea sticky">
            <button type="button" class="btn_p" @click="start">
              웰몰 시작하기
            </button>
          </div>
        </section>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
    <MessagePop v-if="messagePop" @close="messagePop = false">
      <p v-html="msg"></p>
    </MessagePop>
  </div>
  <!-- wrapper(e) -->
</template>
<script>
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';
import MessagePop from '@/components/popup/MessagePop';
//import { JOIN_MISSION_SUCCESS, JOIN_MISSION_FAIL } from '@/store/message.type.js';
import { SET_JOIN_INFO } from '@/store/mutations.type';
import { isEmpty } from '@/common/common.function';

export default {
  name: 'JoinStep5',
  created() {
    console.log(this.$store.getters.guestProduct);
    this.joinInfo = this.$store.getters.joinInfo;
    this.userId = this.joinInfo.userId;
    this.join(); // 로그인 처리
  },
  mounted() {
    this.$refs.header.pushUpdate(this.joinInfo.agreeAppPush, this.userId);
    this.time = window.localStorage.getItem('time');
    this.couponList = this.$route.params.couponList;
    this.success = this.$route.params.succededTimeMission;
  },
  data() {
    return {
      time: null,
      couponList: [],
      success: false,
      msg: null,
      messagePop: false,
      joinInfo: Object,
      userId: '',
    };
  },
  components: {
    MessagePop,
  },
  methods: {
    coupon: function() {
      /*
      if (this.success) this.msg = JOIN_MISSION_SUCCESS;
      else this.msg = JOIN_MISSION_FAIL;
      this.messagePop = true;
      */
      ApiService.service('POST', 'user/login', {
        request: {
          password: this.joinInfo.password,
          userId: this.joinInfo.userId,
        },
        serviceType: 'app',
      })
        .then(({ data }) => {
          console.log(data);

          if (data.isSucceed) {
            this.$router.push({ name: 'benefitsCoupon', params: { downCoupon: false } });
          }
        })
        .catch(({ response }) => {
          console.log(response);
        })
        .finally(() => {
          this.$store.commit(SET_JOIN_INFO, null);
        });
    },
    join: function() {
      ApiService.service('POST', 'user/login', {
        request: {
          password: this.joinInfo.password,
          userId: this.joinInfo.userId,
        },
        serviceType: 'app',
      })
        .then(({ data }) => {
          console.log(data);

          if (data.isSucceed) {
            this.token = data.result.token;
            JwtService.saveToken(this.token);
            JwtService.setUserInfo(data.result.userInfoDto);
          }
        })
        .catch(({ response }) => {
          console.log(response);
        })
        .finally(() => {
          this.$store.commit(SET_JOIN_INFO, null);
        });
    },
    start() {
      const orderCommInfo = this.$store.getters.orderCommInfo;
      const paymentInfo = this.$store.getters.paymentInfo;
      if (!isEmpty(orderCommInfo)) {
        // 렌탈
        this.$router.replace({ name: 'memberMain', params: { orderCommInfo: orderCommInfo } });
      } else if (!isEmpty(paymentInfo)) {
        // 일시불
        this.$router.replace({ name: 'paymentMemberMain', params: { paymentInfo: paymentInfo } });
      } else {
        this.$router.replace('/');
      }
    },
  },
};
</script>
